import useAnalytics from "@/core/plugins/analytics/useAnalytics";
import useStorage from "@/core/plugins/useStorage";
import { useRouter } from "vue-router";

export enum ECategoriaInsightsIA {
  categoria = "F360 - Insights de IA - DRE"
}

export enum AnalyticsInsightsIA {
  ativar_agente = "Ativar agente",
  salvar = "Salvar",
  salvar_data = "Salvar data",
  salvar_telefone = "Salvar telefone",
  confirmar_telefone = "Confirmar telefone",
  exportar_dados_dre = "Exportar DRE",
  configuracoes = "Configurações",
  confirmar = "Confirmar"
}

export default function useAnalyticsInsightsIA() {
  const storage = useStorage();
  const router = useRouter();

  const { sendEvent } = useAnalytics(storage, router);

  const sendClickEvent = (action: string) => {
    console.log("analytics:", {
      evento: ECategoriaInsightsIA.categoria,
      acao: action
    });

    sendEvent(ECategoriaInsightsIA.categoria, action);
  };

  return {
    sendClickEvent
  };
}
